export default __webpack_public_path__ + "static/media/Old_devor1.74305f02.png";